export default __webpack_public_path__ + "static/media/Tick.c6d9b3ba.svg";